import * as React from 'react'

import {
  getDirectorJoinUrl,
  getLoginUrl,
  getParentJoinUrl,
  getWhitelabelBranding,
} from 'main/components/common/AuthModal/ssoNavigation'
import { useWhitelabel } from 'main/framework'
import useSSOContext from 'main/hooks/useSSOContext'

import { ExistingUser } from '../common'
import { ISSOTrackingProps } from '../types'
import { ChooseContainer, StyledButton } from './ChooseRole.styles'

function ChooseRoleSSO(props: ISSOTrackingProps) {
  const { navContext } = useSSOContext() // this page doesn't set its own nav context but might pass along some
  const whitelabel = useWhitelabel()

  const extraContext = {
    networkId: props?.extraData?.networkId || whitelabel?.networkId,
    ...getWhitelabelBranding(whitelabel),
  }

  const directorJoinUrl = getDirectorJoinUrl(props, navContext, extraContext)
  const parentJoinUrl = getParentJoinUrl(props, navContext, extraContext)
  const loginUrl = getLoginUrl(props, navContext, extraContext)

  return (
    <>
      <a href={directorJoinUrl}>
        <StyledButton kind="outline" full>
          Child care provider
        </StyledButton>
      </a>

      <a href={parentJoinUrl}>
        <StyledButton kind="outline" full>
          Parent
        </StyledButton>
      </a>

      <ChooseContainer>
        <ExistingUser
          onRequestLogin={() => {
            window.location.assign(loginUrl)
          }}
        />
      </ChooseContainer>
    </>
  )
}

export default React.memo(ChooseRoleSSO)
